import React from 'react'
import { Link } from 'react-router-dom'

function Settings() {
    const user = JSON.parse(localStorage.getItem('user'))
    let deletePath = '/profile/delete-account'  // <-- use let here

    if (user?.user_type === 'seller') {
        deletePath = '/seller/settings/delete-account'
    } else if (user?.user_type === 'admin') {
        deletePath = '/admin/settings/delete-account'
    } else if (user?.user_type === 'customer') {
        deletePath = '/profile/settings/delete-account'
    }

    return (
        <div className="flex justify-center items-center min-h-screen mx-5 md:mx-0">
            <nav className="w-full max-w-md">
                <ul className="space-y-4">
                    <li>
                        <Link
                            to="/country"
                            className="flex justify-between items-center p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition"
                        >
                            <span>Country</span>
                            <span>{'>'}</span>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/language"
                            className="flex justify-between items-center p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition"
                        >
                            <span>Language</span>
                            <span>{'>'}</span>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/currency"
                            className="flex justify-between items-center p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition"
                        >
                            <span>Currency</span>
                            <span>{'>'}</span>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to={deletePath}
                            className="flex justify-between items-center p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition"
                        >
                            <span>Delete my Account</span>
                            <span>{'>'}</span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Settings
